export default {
	methods: {
		getCurrentRouteMeta(key) {
			if (this.$route) {
				for (let i = this.$route.matched.length - 1; i >= 0; i -= 1) {
					if (this.$route.matched[i].meta[key]) {
						return this.$route.matched[i].meta[key];
					}
				}
			}
			return undefined;
		}
	}
};
